import { z } from 'zod';

import { BaseFlowBlockSchema, BlockType, ProducedType } from '../../base/baseSchema.js';
import { BlockValueTemplateDurationSchema } from '../../base/blockValueTemplateDurationSchema.js';
import { SubFlowV2BlockConfigSchema } from '../../subFlow/v2/config.js';

export const IteratorV2BlockConfigSchema = z.object({
  /**
   * A list of items to iterate: run the sub-flow for each item
   */
  items: z.string().or(z.array(z.unknown())),

  /**
   * The sub-flow to execute for each entry in the list
   */
  subFlow: SubFlowV2BlockConfigSchema,

  /**
   * (Optional) A duration to wait between each item in the list
   */
  iterationStepDuration: BlockValueTemplateDurationSchema().optional(),
});

export const IteratorV2BlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.IteratorV2),
  config: IteratorV2BlockConfigSchema,
  returnType: z.literal(ProducedType.Any).default(ProducedType.Any),
});

export type IteratorV2Block = z.infer<typeof IteratorV2BlockSchema>;
